import { connect } from 'react-redux'
import Organizations from '../../components/organizations/Organizations'
import { getAllOrganizations, setCurrentOrganization, switchOrganization } from '../../state/actions/organizations/'
import {
  getCurrentOrganizationId,
  getOrganizationList,
  getOrganizationListFetching,
  getOrganizationListFetchingError
} from '../../state/reducers/organizations'
import { IStoreState, LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY } from '../../types'

export function mapStateToProps(state: IStoreState) {
  return {
    isFetchingOrganizations: getOrganizationListFetching(state),
    organizations: getOrganizationList(state),
    error: getOrganizationListFetchingError(state),
    currentOrganizationId: getCurrentOrganizationId(state)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getAllOrganizations: () => dispatch(getAllOrganizations()),
    changeOrganization: (orgId: string) => {
      localStorage.setItem(LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY, orgId)
      dispatch(setCurrentOrganization(orgId))
      dispatch(switchOrganization(orgId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Organizations)



// WEBPACK FOOTER //
// ./src/containers/organizations/Organizations.ts